import {
  OAuthProviderType,
  ServerDeploymentType,
  ServerFeature,
} from '@affine/graphql';
import { BRAND_DISPLAY_NAME } from '@streamlain/brand';

import type { ServerConfig, ServerMetadata } from './types';

const STREAMLAIN_SERVER_CONFIG: ServerConfig = {
  serverName: `${BRAND_DISPLAY_NAME} Cloud`,
  features: [
    ServerFeature.Indexer,
    ServerFeature.Copilot,
    ServerFeature.CopilotEmbedding,
    ServerFeature.OAuth,
    ServerFeature.Payment,
    ServerFeature.LocalWorkspace,
  ],
  oauthProviders: [OAuthProviderType.Google],
  type: ServerDeploymentType.Affine,
  credentialsRequirement: {
    password: {
      minLength: 12,
      maxLength: 32,
    },
  },
};

export const BUILD_IN_SERVERS: (ServerMetadata & { config: ServerConfig })[] = [
  {
    id: 'streamlain-cloud',
    baseUrl: BUILD_CONFIG.debug
      ? BUILD_CONFIG.isElectron
        ? 'http://localhost:8080'
        : location.origin
      : BUILD_CONFIG.isElectron
        ? BUILD_CONFIG.cloudBaseUrl
        : location.origin,
    config: STREAMLAIN_SERVER_CONFIG,
  },
];
